<template>
  <div class="text-center my-5">
    <h1 class="text-primary text-uppercase">{{$t($getConst.pages.allowed.not_allowed)}}</h1>
    <h3>{{$t($getConst.pages.allowed.not_allowed_access)}}</h3>
  </div>
</template>

<script>
  import AppSection from "../../components/common/sections/AppSection";
  export default {
    name: "NotAllowed",
    components: {AppSection},
  }
</script>

<style scoped>

</style>
